var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video-section", class: { single: _vm.single } },
    [
      _c("silent-box", {
        attrs: { gallery: _vm.formattedMedia, autoplay: true },
        scopedSlots: _vm._u([
          {
            key: "silentbox-item",
            fn: function(ref) {
              var silentboxItem = ref.silentboxItem
              return [
                _c("div", { staticClass: "thumbnail" }, [
                  silentboxItem.type === "image"
                    ? _c("img", {
                        staticClass: "lazyload",
                        attrs: {
                          "data-src": silentboxItem.src,
                          alt: silentboxItem.alt
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  silentboxItem.type === "video"
                    ? _c("img", {
                        staticClass: "lazyload",
                        attrs: {
                          "data-src": silentboxItem.thumbnail,
                          alt: silentboxItem.alt
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  silentboxItem.type === "video"
                    ? _c("div", {
                        staticClass: "play-button",
                        domProps: { innerHTML: _vm._s(_vm.svg("play")) }
                      })
                    : _vm._e()
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }